<template>
    <v-toolbar-items>
        <v-btn 
            class="#eff7f6 black--text" 
            text
            v-for="(tab, idx) in commonTabs"
            :key="idx"
            router
            :to="getRouterTo(tab.routerLink)"
            @click="headerTabClick(tab.routerLink)">
            <v-icon left>{{ tab.icon }}</v-icon>
            <span>{{ $t(tab.name) }}</span>
        </v-btn>
    </v-toolbar-items>
</template>

<script>
import {mapGetters} from "vuex";
export default {
    name: "HeaderTabs",
    computed: {
        ...mapGetters(["commonTabs"])
    },
    methods: {
        getRouterTo(routerLink) {
            var routeObj = {
                name: routerLink,
                params: {
                    lang: this.$i18n.locale
                }
            }
            if (routerLink === "myWork") {
                routeObj.params.type = "thesis";
            }
            return routeObj;
        },
        headerTabClick(routerLink) {
            this.logEvent("button_click", {
                name: "headerTab",
                link: routerLink
            });
        }
    }
}
</script>

<style scoped>
.v-btn.v-size--default {
    font-size: 1em;
}
</style>